// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qrcom_container__5ftib{
    padding: 0 15px;
    margin: 0 auto;
    width: 100%;
}

.qrcom_hv100__lKuJW{
    min-height: 100vh;
}

.qrcom_bgcolor__0VLrH{
    background: #0D0E11;
}
.qrcom_bgamount__seqWj{
    background: #16191F;
}

.qrcom_hrbgcolor__4hAIN{
    background: #4F5568;
}
.qrcom_hrborddot__BvRfV{
    border: 1px dotted #4F5568;
}

.qrcom_fontColorRed__lRs74{
    color: #FF0000;
}


.qrcom_br4__v3sYL{
    border-radius: 4px; 
}
.qrcom_border353945__aCtMc{
    border: 1px solid #353945;
}
.qrcom_border4F5568__USVmz{
    border: 1px solid #4F5568;
}
.qrcom_background353945__Wqxz8{
    background: #353945;
}
.qrcom_background4F5568__b\\+d7V{
    background: #4F5568;
}

.qrcom_hpx1__8i\\+It{
    height: 1px;
}

.qrcom_fontColorWhite__zvqEP{
    color: #F3F4F6;
}
.qrcom_fontColorGray__dn6LT{
    color: #9396A3;
}

.qrcom_fontFamilyNotoSans__\\+UTAm{
    font-family: "Noto Sans";
}

.qrcom_wperc100__4wiHO{
    width: 100%;
}

.qrcom_displayFlex__5rxQM{
    display: flex;
}
.qrcom_flexStyle__0Bd2T{
    display: flex;
    align-items: center;
}
.qrcom_justifyContentStart__xeA\\+J{
    justify-content: flex-start;
}
.qrcom_justifyContentCenter__bBW6H{
    justify-content: center;
}
.qrcom_justifyContentEnd__gHIAr{
    justify-content: flex-end;
}
.qrcom_justifyContentBetween__2yBK5{
    justify-content: space-between;
}
.qrcom_justifyContentAround__Y2Q0s{
    justify-content: space-around;
}
.qrcom_justifyContentEvenly__Uq3-z{
    justify-content: space-evenly;
}
.qrcom_alignItemsCenter__gyvS5{
    align-items: center;
}

.qrcom_gap10__BSJeK{
    gap: 10px;
}
.qrcom_gap11__xdAj3{
    gap: 11px;
}
.qrcom_gap4__BsTcP{
    gap: 4px;
}
.qrcom_flexDirecRow__wwWgr{
    flex-direction: row;
}
.qrcom_flexDirecColumn__m1rhH{
    flex-direction: column;
}


.qrcom_p20__\\+VUBV{
    padding: 20px;
}
.qrcom_p140__R1G0m{
    padding: 14px 0px;
}
.qrcom_p1415__vvkrH{
    padding: 14px 15px;
}
.qrcom_p48__p6BJf{
    padding: 4px 8px;
}
.qrcom_p1213__qFIcm{
    padding: 12px 13px;
}
.qrcom_p20202012__iCf4g{
    padding: 20px 20px 12px 20px;
}

.qrcom_martop10__jIUGI{
    margin-top: 10px;
}
.qrcom_martop20__f\\+Sad{
    margin-top: 20px;
}
.qrcom_marbottom20__nVxLv{
    margin-bottom: 20px;

}

.qrcom_br12__7pkH1{
    border-radius: 12px;
}

.qrcom_fontSize12__o2mJc{
    font-size: 12px;
}
.qrcom_fontSize16__9QNlA{
    font-size: 16px;
}
.qrcom_fontWeight400__24r7A{
    font-weight: 400;
}
.qrcom_fontWeight500__4Dn1z{
    font-weight: 500;
}
.qrcom_lineHeight20__rnUIO{
    line-height: 20px;
}

.qrcom_fontWeight600__BYcRB{
    font-weight: 600;
}
.qrcom_lineHeight24__HmcV8{
    line-height: 24px;
}

.qrcom_br20__nSoTj{
    border-radius: 20px;
}

.qrcom_border2__7FrA0{
    border: 2px solid #353945;
}

.qrcom_boxShadow6__9klMN{
    box-shadow: 0 6px 0 0 #353945;
}

.qrcom_scannerbox__aftdN{
    width: 100%;
    height: 100%;
}

.qrcom_paymentIconWrapper__RhINB{
    background: #fff;
    border-radius: 100%;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/components/QrCode/qrcom.module.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,cAAc;IACd,WAAW;AACf;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;AACA;IACI,0BAA0B;AAC9B;;AAEA;IACI,cAAc;AAClB;;;AAGA;IACI,kBAAkB;AACtB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,8BAA8B;AAClC;AACA;IACI,6BAA6B;AACjC;AACA;IACI,6BAA6B;AACjC;AACA;IACI,mBAAmB;AACvB;;AAEA;IACI,SAAS;AACb;AACA;IACI,SAAS;AACb;AACA;IACI,QAAQ;AACZ;AACA;IACI,mBAAmB;AACvB;AACA;IACI,sBAAsB;AAC1B;;;AAGA;IACI,aAAa;AACjB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,4BAA4B;AAChC;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,mBAAmB;;AAEvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;AACA;IACI,eAAe;AACnB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B","sourcesContent":[".container{\n    padding: 0 15px;\n    margin: 0 auto;\n    width: 100%;\n}\n\n.hv100{\n    min-height: 100vh;\n}\n\n.bgcolor{\n    background: #0D0E11;\n}\n.bgamount{\n    background: #16191F;\n}\n\n.hrbgcolor{\n    background: #4F5568;\n}\n.hrborddot{\n    border: 1px dotted #4F5568;\n}\n\n.fontColorRed{\n    color: #FF0000;\n}\n\n\n.br4{\n    border-radius: 4px; \n}\n.border353945{\n    border: 1px solid #353945;\n}\n.border4F5568{\n    border: 1px solid #4F5568;\n}\n.background353945{\n    background: #353945;\n}\n.background4F5568{\n    background: #4F5568;\n}\n\n.hpx1{\n    height: 1px;\n}\n\n.fontColorWhite{\n    color: #F3F4F6;\n}\n.fontColorGray{\n    color: #9396A3;\n}\n\n.fontFamilyNotoSans{\n    font-family: \"Noto Sans\";\n}\n\n.wperc100{\n    width: 100%;\n}\n\n.displayFlex{\n    display: flex;\n}\n.flexStyle{\n    display: flex;\n    align-items: center;\n}\n.justifyContentStart{\n    justify-content: flex-start;\n}\n.justifyContentCenter{\n    justify-content: center;\n}\n.justifyContentEnd{\n    justify-content: flex-end;\n}\n.justifyContentBetween{\n    justify-content: space-between;\n}\n.justifyContentAround{\n    justify-content: space-around;\n}\n.justifyContentEvenly{\n    justify-content: space-evenly;\n}\n.alignItemsCenter{\n    align-items: center;\n}\n\n.gap10{\n    gap: 10px;\n}\n.gap11{\n    gap: 11px;\n}\n.gap4{\n    gap: 4px;\n}\n.flexDirecRow{\n    flex-direction: row;\n}\n.flexDirecColumn{\n    flex-direction: column;\n}\n\n\n.p20{\n    padding: 20px;\n}\n.p140{\n    padding: 14px 0px;\n}\n.p1415{\n    padding: 14px 15px;\n}\n.p48{\n    padding: 4px 8px;\n}\n.p1213{\n    padding: 12px 13px;\n}\n.p20202012{\n    padding: 20px 20px 12px 20px;\n}\n\n.martop10{\n    margin-top: 10px;\n}\n.martop20{\n    margin-top: 20px;\n}\n.marbottom20{\n    margin-bottom: 20px;\n\n}\n\n.br12{\n    border-radius: 12px;\n}\n\n.fontSize12{\n    font-size: 12px;\n}\n.fontSize16{\n    font-size: 16px;\n}\n.fontWeight400{\n    font-weight: 400;\n}\n.fontWeight500{\n    font-weight: 500;\n}\n.lineHeight20{\n    line-height: 20px;\n}\n\n.fontWeight600{\n    font-weight: 600;\n}\n.lineHeight24{\n    line-height: 24px;\n}\n\n.br20{\n    border-radius: 20px;\n}\n\n.border2{\n    border: 2px solid #353945;\n}\n\n.boxShadow6{\n    box-shadow: 0 6px 0 0 #353945;\n}\n\n.scannerbox{\n    width: 100%;\n    height: 100%;\n}\n\n.paymentIconWrapper{\n    background: #fff;\n    border-radius: 100%;\n    width: 32px;\n    height: 32px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `qrcom_container__5ftib`,
	"hv100": `qrcom_hv100__lKuJW`,
	"bgcolor": `qrcom_bgcolor__0VLrH`,
	"bgamount": `qrcom_bgamount__seqWj`,
	"hrbgcolor": `qrcom_hrbgcolor__4hAIN`,
	"hrborddot": `qrcom_hrborddot__BvRfV`,
	"fontColorRed": `qrcom_fontColorRed__lRs74`,
	"br4": `qrcom_br4__v3sYL`,
	"border353945": `qrcom_border353945__aCtMc`,
	"border4F5568": `qrcom_border4F5568__USVmz`,
	"background353945": `qrcom_background353945__Wqxz8`,
	"background4F5568": `qrcom_background4F5568__b+d7V`,
	"hpx1": `qrcom_hpx1__8i+It`,
	"fontColorWhite": `qrcom_fontColorWhite__zvqEP`,
	"fontColorGray": `qrcom_fontColorGray__dn6LT`,
	"fontFamilyNotoSans": `qrcom_fontFamilyNotoSans__+UTAm`,
	"wperc100": `qrcom_wperc100__4wiHO`,
	"displayFlex": `qrcom_displayFlex__5rxQM`,
	"flexStyle": `qrcom_flexStyle__0Bd2T`,
	"justifyContentStart": `qrcom_justifyContentStart__xeA+J`,
	"justifyContentCenter": `qrcom_justifyContentCenter__bBW6H`,
	"justifyContentEnd": `qrcom_justifyContentEnd__gHIAr`,
	"justifyContentBetween": `qrcom_justifyContentBetween__2yBK5`,
	"justifyContentAround": `qrcom_justifyContentAround__Y2Q0s`,
	"justifyContentEvenly": `qrcom_justifyContentEvenly__Uq3-z`,
	"alignItemsCenter": `qrcom_alignItemsCenter__gyvS5`,
	"gap10": `qrcom_gap10__BSJeK`,
	"gap11": `qrcom_gap11__xdAj3`,
	"gap4": `qrcom_gap4__BsTcP`,
	"flexDirecRow": `qrcom_flexDirecRow__wwWgr`,
	"flexDirecColumn": `qrcom_flexDirecColumn__m1rhH`,
	"p20": `qrcom_p20__+VUBV`,
	"p140": `qrcom_p140__R1G0m`,
	"p1415": `qrcom_p1415__vvkrH`,
	"p48": `qrcom_p48__p6BJf`,
	"p1213": `qrcom_p1213__qFIcm`,
	"p20202012": `qrcom_p20202012__iCf4g`,
	"martop10": `qrcom_martop10__jIUGI`,
	"martop20": `qrcom_martop20__f+Sad`,
	"marbottom20": `qrcom_marbottom20__nVxLv`,
	"br12": `qrcom_br12__7pkH1`,
	"fontSize12": `qrcom_fontSize12__o2mJc`,
	"fontSize16": `qrcom_fontSize16__9QNlA`,
	"fontWeight400": `qrcom_fontWeight400__24r7A`,
	"fontWeight500": `qrcom_fontWeight500__4Dn1z`,
	"lineHeight20": `qrcom_lineHeight20__rnUIO`,
	"fontWeight600": `qrcom_fontWeight600__BYcRB`,
	"lineHeight24": `qrcom_lineHeight24__HmcV8`,
	"br20": `qrcom_br20__nSoTj`,
	"border2": `qrcom_border2__7FrA0`,
	"boxShadow6": `qrcom_boxShadow6__9klMN`,
	"scannerbox": `qrcom_scannerbox__aftdN`,
	"paymentIconWrapper": `qrcom_paymentIconWrapper__RhINB`
};
export default ___CSS_LOADER_EXPORT___;
